export const getStatusColor = (status: string) => {
    if (status === 'in_review') return 'bg-yellow-100 text-yellow-700';
    if (status === 'approved') return 'bg-green-100 text-green-700';

    return 'bg-gray-100 text-gray-700 border-gray-200';
};
